// extracted by mini-css-extract-plugin
module.exports = {"weddingPlanning":"WorksCase_style_weddingPlanning__2OXEB"};